__turbopack_context__.v({
  "faqSection": "Txs6ka_faqSection",
  "footerText": "Txs6ka_footerText",
  "isBlog": "Txs6ka_isBlog",
  "items": "Txs6ka_items",
  "noIdentImage": "Txs6ka_noIdentImage",
  "paddingBottom0": "Txs6ka_paddingBottom0",
  "paddingBottom112": "Txs6ka_paddingBottom112",
  "paddingBottom128": "Txs6ka_paddingBottom128",
  "paddingBottom16": "Txs6ka_paddingBottom16",
  "paddingBottom32": "Txs6ka_paddingBottom32",
  "paddingBottom48": "Txs6ka_paddingBottom48",
  "paddingBottom64": "Txs6ka_paddingBottom64",
  "paddingBottom80": "Txs6ka_paddingBottom80",
  "paddingBottom96": "Txs6ka_paddingBottom96",
  "paddingTop0": "Txs6ka_paddingTop0",
  "paddingTop112": "Txs6ka_paddingTop112",
  "paddingTop128": "Txs6ka_paddingTop128",
  "paddingTop16": "Txs6ka_paddingTop16",
  "paddingTop32": "Txs6ka_paddingTop32",
  "paddingTop48": "Txs6ka_paddingTop48",
  "paddingTop64": "Txs6ka_paddingTop64",
  "paddingTop80": "Txs6ka_paddingTop80",
  "paddingTop96": "Txs6ka_paddingTop96",
  "title": "Txs6ka_title",
});
